<template>
  <div class="cloudcix_login_container">
    <div class="cloudcix_login_box">
      <div class="welcome_container">
        <img v-if="url" :src="url" class="logo_image" :style="imageStyle" />
      <h3 class="cloudcix_login_heading">{{ welcomeText }}</h3>
    </div>
      <form @submit.prevent="login" class="cloudcix_login_form">
        <div class="cloudcix_form_group">
          <input type="email" id="email" class="cloudcix_form_input" v-model="email" @blur="validateEmail" placeholder="Email" required />
           <p v-if="emailError" class="error">{{ emailError }}</p>
        </div>
        <div class="cloudcix_form_group">
          <input id="password" class="cloudcix_form_input" v-model="password" @blur="validatePassword" :type="showPassword ? 'text' : 'password'"
            placeholder="Password" required />
          <button @click="togglePasswordVisibility" v-tooltip.top="showPassword ? 'Hide Password' : 'Show Password'"
            type="button" class="cloudcix_password_toggle_button">
            <svg xmlns="http://www.w3.org/2000/svg" height="1em"
              viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
              <path
                d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
            </svg>
          </button>
        </div>
        <p v-if="passwordError" class="error">{{ passwordError }}</p>
        <button type="submit" label="Login" :style="{ backgroundColor: button_background_colour, color: button_text_colour }" class="cloudcix_login_button">Login</button>
        <div style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 10px;">
          <a @click="forgotPassword" class="cloudcix_forgot_password_link">Forgot Password?</a>
          <a @click="signup" class="cloudcix_signup_link">Sign up</a>
        </div>
        <button @click="guest" label="Use as Guest" :style="{ backgroundColor: button_background_colour, color: button_text_colour, marginTop: '10px' }" class="cloudcix_login_button">Use as Guest</button>

        <!-- Email Dialog -->
        <DialogBox v-model:visible="emailDialogVisible" header="Forgot Password"  class="dialog-box" :style="{ width: '50%', 'border-radius': '8px'  }"
          @onHide="onHideEmailDialog">
          <p>Enter your email to receive an OTP:</p>
          <input class="cloudcix_form_input" v-model="forgotPasswordEmail" type="text" placeholder="Email">
          <p v-if="forgotEmailError" class="error">{{ forgotEmailError }}</p>
          <div class="single-button-container">
            <button @click="sendOTP" :style="{ backgroundColor: button_background_colour, color: button_text_colour }" class="cloudcix_login_button">Send OTP</button>
          </div>
        </DialogBox>

        <!-- OTP Dialog -->
        <DialogBox v-model:visible="otpDialogVisible" header="Enter OTP" :style="{ width: '50vw' }" @onHide="onHideOTPDialog">
          <p>Check your email for the OTP and enter it below:</p>
          <input class="cloudcix_form_input" v-model="otp" type="text" placeholder="OTP">
          <p :style="{ color: expirationMessageColor }" v-if="showExpirationMessage">{{ expirationMessage }}</p>
          <div class="single-button-container">
            <button @click="sendOTP" :style="{ backgroundColor: button_background_colour, color: button_text_colour, display: sendButtonDisplay }" class="cloudcix_login_button">Resend OTP</button>
            <button @click="verifyOTP" :style="{ backgroundColor: button_background_colour, color: button_text_colour, display: verifyButtonDisplay }" class="cloudcix_login_button">Verify OTP</button>
          </div>
        </DialogBox>

        <!-- New Password Dialog -->
        <DialogBox v-model:visible="newPasswordDialogVisible" header="Set New Password" :style="{ width: '50vw' }" @onHide="onHideNewPasswordDialog">
          <div class="cloudcix_form_group">
              <p>Enter your new password:</p>
              <input id="confirmPassword" class="cloudcix_form_input" @blur="validateNewPassword" v-model="newPassword" :type="showPassword ? 'text' : 'password'"
                        placeholder="New Password" required />
          </div>
          <p>Confirm your new password:</p>
          <div class="cloudcix_form_group">
            <input id="confirmPassword" class="cloudcix_form_input" @blur="validateConfirmPassword" v-model="confirmPassword" :type="showPassword ? 'text' : 'password'"
            placeholder="Confirm Password" required />
            <button @click="togglePasswordVisibility" v-tooltip.top="showPassword ? 'Hide Password' : 'Show Password'"
            type="button" class="cloudcix_password_toggle_button">
                <svg xmlns="http://www.w3.org/2000/svg" height="1em"
                viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                <path
                  d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
                </svg>
            </button>
          </div>
          <p v-if="passwordError" class="error">{{ passwordError }}</p>
          <div class="single-button-container">
            <button @click="updatePassword" :style="{ backgroundColor: button_background_colour, color: button_text_colour }" class="cloudcix_login_button">Update Password</button>
          </div>
        </DialogBox>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
export default {
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      forgotPasswordEmail: "",
      welcomeText: "",
      url: "",
      button_background_colour: "",
      button_text_colour: "",
      actualWidth: 0,
      actualHeight: 0,
      emailError: null,
      forgotEmailError: null,
      passwordError: null,
      emailDialogVisible: false,
      otpDialogVisible: false,
      newPasswordDialogVisible: false,
      otp: "",
      newPassword: "",
      confirmPassword: "",
      expirationTime: 5 * 60, // in seconds
      showExpirationMessage: false,
      expirationMessageColor: 'green',
      timeRemaining: 5 * 60,
      expirationMessage: '',
      verifyButtonDisplay: 'visible',
      sendButtonDisplay: 'none',
    };
  },
  props: ['paramValue'],
  methods: {
    ...mapActions({
      loginUser: "loginUser",
      fetchIframeProperties: "fetchIframeProperties",
      forgotPasswordEmailValidation: "forgotPasswordEmailValidation",
      otpValidation: "otpValidation",
      newPasswordValidation: "newPasswordValidation",
    }),
     validateEmailFormat(email) {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!emailPattern.test(email)) {
        return 'Invalid email address';
      }
      return null;
    },
    validateEmail() {
      this.emailError = this.validateEmailFormat(this.email);
    },
    validateForgotPasswordEmail() {
      this.emailForgotError = this.validateEmailFormat(this.forgotPasswordEmail);
    },
    validatePasswordFormat(password) {
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#?!@$%^&*-])[A-Za-z\d#?!@$%^&*-]{8,}$/;
          if (!passwordPattern.test(password)) {
            return 'Invalid password format';
          }return null;
    },

    validatePassword(){
      this.passwordError = this.validatePasswordFormat(this.password);
    },

    validateNewPassword(){
      this.passwordError = this.validatePasswordFormat(this.newPassword);
    },

    validateConfirmPassword(){
      this.passwordError = this.validatePasswordFormat(this.confirmPassword);
    },


    showToast(msg, severity= "success", lifeTime = 2500) {
      let tconfig = {
        summary: msg,
        severity: severity,
      };
      if (lifeTime) {
        tconfig["life"] = lifeTime;
      }
      this.$toast.add(tconfig);
    },
    async login() {
     this.validateEmail();
     this.validatePassword();
     if (!this.emailError && !this.passwordError) {
          let payload = {
            email: this.email,
            password: this.password,
          }
          try{
              const resp = await this.loginUser(payload)
              if (resp && resp.status != 200) {
                 this.showToast("The credentials doesn't exist. Please check & try again.", "error");
              } else {
                this.$router.push({ name: 'ChatbotPage' });
              }
          }catch(error){
                this.showToast("The sent email and password combination is invalid. Please check both and try again.", "error")
          }
     }
    },
    signup() {
      this.$router.push({ name: 'Signup' });
    },
    guest() {
        let cookie = sessionStorage.getItem('cookie')
        if (!cookie) {
          let uniqueId = uuidv4()
          sessionStorage.setItem('cookie', uniqueId)
        }
        this.$router.push({ name: 'GuestChat' });
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    forgotPassword() {
      this.emailDialogVisible = true;
    },
    onHideEmailDialog() {
      this.emailDialogVisible = false;
    },
    resetTimer() {
  // Reset the timer and show the expiration message
  this.timeRemaining = this.expirationTime;
  this.showExpirationMessage = true;

  // Start the countdown timer
  this.startTimer();
},

startTimer() {
  const startTime = Date.now();

  const updateTimer = () => {
    const currentTime = Date.now();
    const elapsedSeconds = Math.floor((currentTime - startTime) / 1000);

    this.timeRemaining = Math.max(this.expirationTime - elapsedSeconds, 0);

    if (this.timeRemaining === 0) {
      // Time is up, hide the expiration message
      this.showExpirationMessage = true;
      this.expirationMessage = 'OTP expired';
      this.expirationMessageColor = 'red';
      this.verifyButtonDisplay = 'none';
      this.sendButtonDisplay = 'block';
    } else {
      // Show the dynamic expiration message
      this.verifyButtonDisplay = 'block';
      this.sendButtonDisplay = 'none';
      this.expirationMessageColor = 'green';

      const minutes = Math.floor(this.timeRemaining / 60);
      const seconds = this.timeRemaining % 60;
      this.expirationMessage = `OTP expires in ${minutes} min ${seconds} sec`;

      // Continue updating the timer
      requestAnimationFrame(updateTimer);
    }
  };

  // Start the timer
  updateTimer();
},

    async sendOTP() {
      this.validateForgotPasswordEmail();
      if (!this.forgotEmailError){
            let payload= {
                email: this.forgotPasswordEmail
            }
        const resp = await this.forgotPasswordEmailValidation(payload)
        if(resp.data.Message.indexOf('not') === -1){
          this.showToast(resp.data.Message);
          this.emailDialogVisible = false;
          this.otpDialogVisible = true;
          this.showExpirationMessage = false;
          // Reset the timer for the next OTP
          this.resetTimer();
        }else{
          this.showToast(resp.data.Message, "error");
          this.emailDialogVisible = false;
          this.signup = true;
          this.forgotPasswordEmail = '';
        }
      }
    },
    onHideOTPDialog() {
      this.otpDialogVisible = false;
    },
    async verifyOTP() {
         let payload= {
           email: this.forgotPasswordEmail,
           otp: this.otp,
         }
         try {
              const resp = await this.otpValidation(payload);
              if (resp.status === 200) {
                this.showToast(resp.data.Message);
                this.otpDialogVisible = false;
                this.otp ='';
                this.newPasswordDialogVisible = true;
              }
            } catch (error) {
              if (error.response) {
                this.showToast(error.response.data.Message, "error");
                this.otpDialogVisible = true;
              }
            }
    },
    onHideNewPasswordDialog() {
      this.newPasswordDialogVisible = false;
    },
    async updatePassword() {
        // Implement your password update logic here
        this.validateNewPassword();
        this.validateConfirmPassword();
        if (!this.passwordError) {
            let payload= {
                email: this.forgotPasswordEmail,
                newPassword: this.newPassword,
                confirmPassword: this.confirmPassword,
            }
            try {
            // You may want to send a request to your backend to update the password
                const resp = await this.newPasswordValidation(payload)
                if(resp.data.Message.indexOf('Successfully') === -1){
                    this.showToast(resp.data.Message, "error");
                    this.newPasswordDialogVisible = true;
                }else{
                    this.showToast(resp.data.Message);
                    this.newPasswordDialogVisible = false;
                    this.forgotPasswordEmail = '';
                    this.newPassword = '';
                    this.confirmPassword = '';
                    this.signup = true;
                }
            }catch (error) {
                if (error.response) {
                    this.showToast(error.response.data.Message, "error");
                    this.newPasswordDialogVisible = true;
                }
            }
        }
    },
    async fetchInitialInformation(){

      const resp = await this.fetchIframeProperties()
      if(resp){
        this.welcomeText = resp.data.welcome_text
        this.url = resp.data.url
        this.button_background_colour = resp.data.button_background_colour
        this.button_text_colour = resp.data.button_text_colour
      }
    }
  },
   async mounted() {
    await this.fetchInitialInformation()

    // Create a new Image object
    const img = new Image();
    img.src = this.url;
    // When the image is loaded, getting its dimensions
    img.onload = () => {
      this.actualWidth = img.width;
      this.actualHeight = img.height;
    };
  },
  computed: {
    imageStyle(){ // Calculate the maximum dimension (width or height) for the logo
      const maxDimension = 80; // Adjust this value to our preference

      // Calculate the scaled dimensions while maintaining the aspect ratio
      let width, height;

      if (this.actualWidth > this.actualHeight) {
        width = maxDimension;
        height = (this.actualHeight / this.actualWidth) * maxDimension;
      } else {
        height = maxDimension;
        width = (this.actualWidth / this.actualHeight) * maxDimension;
      }

      return {
        width: `${width}px`,
        height: `${height}px`,
      };
    },
  },
};
</script>

<style scoped>
  .dialog-box {
    background-color: #f4f4f4; /* Background color */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Box shadow */
    padding: 20px; /* Padding */
    text-align: center; /* Text alignment */
    border-radius: 8px; /* Border radius */
  }

.two-button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.single-button-container {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.error {
  color: red;
}

.cloudcix_login_container {
  display: flex;
  justify-content: center;
  align-items: center;
  content: fit;
  min-height: 100vh;
  background-color: transparent;
  /* background-image: url('https://www.cloudcix.com/assets/img/CLOUD_CIX_I4_.png'); */
  /* background-size: cover; */
}

.cloudcix_login_box {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  padding: 30px;
  width: 350px;
  text-align: center;
}

.logo_image {
  border-radius: 50%; /* Creates a circular shape */
  margin-right: 0%; /* Adjust the spacing between the image and text */
  border: 2px solid; /* Add a border around the circular image */
  /*box-shadow: 0 0 10px rgba(0, 115, 230, 0.5);*/ /* Add a subtle shadow */
}

.welcome_container {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.cloudcix_login_heading {
  font-size: 28px;
  margin: 0;
  color: #333;
}

.cloudcix_login_form {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.cloudcix_form_group {
  margin-bottom: 20px;
  position: relative;
  width: 100%;
  align-items: center;
}

.password-input-container {
  display: flex;
  align-items: center;

}

#password {
  padding-right: 40px;
}

.cloudcix_password_toggle_button {
  position: absolute;
  right: 12%;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.cloudcix_form_input {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  width: 90%;
}

label {
  font-weight: bold;
  margin-bottom: 6px;
  display: block;
  color: #444;
}

.cloudcix_login_button {
  border: none;
  border-radius: 4px;
  padding: 12px 20px;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.cloudcix_links {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.cloudcix_forgot_password_link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

.cloudcix_signup_link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

.divider {
  margin: 0 10px;
  color: #333;
}

.cloucix_forgot_password_link:hover,
.cloucix_signup_link:hover {
  text-decoration: underline;
}
</style>
